angular.module("tromanWeb").controller('MissionGroupDetailsController', ['stateService', 'tromanServer', 'dialogService', 'missionGroupShared', function (stateService, tromanServer, dialogService, missionGroupShared) {

    let isSaving = false;

    this.$onInit = function $onInit() {
        this.missionGroup = missionGroupShared.missionGroup.clone();
        this.isAdding = !missionGroupShared.missionGroup.Id;

        stateService.guard(() => this.form.$dirty);
    };

    this.canSave = function () {
        return !isSaving && this.form.$dirty && this.form.$valid;
    };

    this.save = function save() {
        if (!this.canSave()) return;

        this.form.$commitViewValue();
        this.form.$setSubmitted();

        if (this.form.$invalid) return;

        isSaving = true;
        if (this.isAdding) {
            tromanServer.MissionGroups.addEntity(this.missionGroup)
                .then(rsp => {
                    stateService.forceGo('missiongroup.details', { missionGroupId: rsp.result.Id }, { reload: true, location: 'replace' });
                })
                .catch(dialogService.error)
                .finally(() => isSaving = false);
        } else {
            tromanServer.MissionGroups.updateEntity(this.missionGroup)
                .then(() => { stateService.forceReload('missiongroup'); })
                .catch(dialogService.error)
                .finally(() => isSaving = false);
        }
    };
}]);
